import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { IPurchaseOrderItemDetail } from "features/budget/purchaseOrder/api/types";
import { IInvoice, IInvoiceGridFilter, IInvoiceGridModel, IInvoiceItemForAccession, IPendingInvoiceSummaryModel } from "./types";
import { InvoiceView } from "../types/invoiceView";

export const invoice = createQueryKeys("invoice", {
  list: (postModel: PostModel<IInvoiceGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IInvoiceGridModel>>(
        endpoints.invoice.list,
        postModel,
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<IInvoice>(`${endpoints.invoice.getById}/${Id}`),
  }),

  getPurchaseOrderItemsForInvoicing: (purchaseOrderId: string | number) => ({
    queryKey: [purchaseOrderId],
    queryFn: () =>
      api.get<{ items: IPurchaseOrderItemDetail[] }>(
        `${endpoints.purchaseOrder.getById}/${purchaseOrderId}`,
      ),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<InvoiceView>(`${endpoints.invoice.view}/${Id}`),
  }),
  getPendingSummary: () => ({
    queryKey: ["pendingSummary"],
    queryFn: () =>
      api.get<IPendingInvoiceSummaryModel[]>(endpoints.invoice.pendingSummary),
  }),
  getAccessionItems: (id: string | number) => ({
    queryKey: ["accessionItems", id],
    queryFn: async () => {
      const res = await api.get<IInvoiceItemForAccession[]>(
        `${endpoints.invoice.accessionItems}/${id}`
      );
      return res;
    },
  }),
});
  
